import { render, staticRenderFns } from "./EditFerts.vue?vue&type=template&id=6508f747&"
import script from "./EditFerts.vue?vue&type=script&lang=js&"
export * from "./EditFerts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports